import type { ReactNode } from 'react';

export const symbol_fire_extinguisher: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M280-244v-237l10-29h380l10 29v237H280Zm61-206v146h280v-146H341Zm177.5-277.5Q534-743 534-766t-15.5-38.5Q503-820 480-820t-38.5 15.5Q426-789 426-766t15.5 38.5Q457-712 480-712t38.5-15.5Zm131.5.5v-78l-59 12q2 7 2.5 13.5t.5 13.5q0 7-.5 13.5T591-739l59 12ZM280-481q0-67 39-118t99-71q-14-9-25-22t-18-29l-156-31q-4-1-6.5-4.5T210-764v-4q0-4 2.5-7.5t6.5-4.5l156-31q13-31 41.5-50t63.5-19q23 0 43 8.5t36 23.5l115-23q14-3 25 6.5t11 23.5v150q0 14-11 23.5t-25 6.5l-115-23q-4 4-8 7.5t-9 6.5q60 20 99 71t39 118h-59q0-60-41.5-100T481-621q-57 0-98.5 40T341-481h-61Zm60 401q-24 0-42-18t-18-42v-104h61v104h280v-104h59v104q0 24-18 42t-42 18H340Z"
		/>
	</svg>
);
